export default __webpack_public_path__ + "static/media/up1.e7f798ab.svg";